import React from 'react'
import css from './tab.module.less'
import { SwitchPageTab } from '../../../components/switchTab'
import { type SearchType } from '../../../searchModal/util'

type TabProps = {
  value:SearchType,
  options: Array<any>,
  onChange: (value:string) => void,
  children: (value:string) => React.ReactNode,
  rightRenderer?: (value:SearchType) => React.ReactNode
}
export default function IndexTab(props:TabProps) {
  const { value, options, onChange, children, rightRenderer } = props
  return <div className={css.container}>
    <SwitchPageTab
      options={options}
      value={value}
      style={{ position: 'relative' }}
      onChange={onChange}
      // eslint-disable-next-line react/jsx-no-useless-fragment
      renderRight={() => <>
        {value === 'sample_clothing' ? rightRenderer?.('sample_clothing') : rightRenderer?.('sample_folder')}
      </>}
    />
    <main className={css.main}>
      {children(value)}
    </main>
  </div>
}
